<div class="change-password-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
  </div>

  <div class="change-password-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="icon-section">
        <mat-icon class="password-icon">lock</mat-icon>
      </div>
      <h1 class="change-title">Set New Password</h1>
      <p class="change-subtitle">Enter your new password to keep it safe</p>
    </div>

    <!-- Main Content -->
    <div class="change-content">
      <!-- Error/Success Messages -->
      @if (errorMessage) {
        <mat-error class="error-message">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
        </mat-error>
      }

      @if (successMessage) {
        <div class="success-message">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
      }

      <!-- Change Password Form -->
      <form [formGroup]="form" #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit(forgotPasswordForm)" class="change-form">
        <div class="form-fields">
          <!-- New Password Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Password</mat-label>
            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              autocomplete="new-password"
              />
            <mat-icon matPrefix>lock</mat-icon>
            <mat-icon matSuffix (click)="hidePassword = !hidePassword" class="password-toggle">
              {{ hidePassword ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            @if (form.get('password')?.touched && form.get('password')?.invalid) {
              <mat-error>
                {{ getPasswordErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>

          @if (shouldShowPasswordRequirements) {
            <div class="password-requirements">
              <div class="requirements-title">Password must contain:</div>
              <div class="requirement-item" [class.requirement-met]="passwordRequirementMinLength">
                <mat-icon class="requirement-icon">{{ passwordRequirementMinLength ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span class="requirement-text">8 characters</span>
              </div>
              <div class="requirement-item" [class.requirement-met]="passwordRequirementUppercase">
                <mat-icon class="requirement-icon">{{ passwordRequirementUppercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span class="requirement-text">1 uppercase letter</span>
              </div>
              <div class="requirement-item" [class.requirement-met]="passwordRequirementLowercase">
                <mat-icon class="requirement-icon">{{ passwordRequirementLowercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span class="requirement-text">1 lowercase letter</span>
              </div>
              <div class="requirement-item" [class.requirement-met]="passwordRequirementNumber">
                <mat-icon class="requirement-icon">{{ passwordRequirementNumber ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span class="requirement-text">1 number</span>
              </div>
              <div class="requirement-item" [class.requirement-met]="passwordRequirementSpecial">
                <mat-icon class="requirement-icon">{{ passwordRequirementSpecial ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span class="requirement-text">1 special character (. # ? ! @ $ % ^ & * -)</span>
              </div>
              <div class="requirement-item requirement-previous">
                <mat-icon class="requirement-icon">radio_button_unchecked</mat-icon>
                <span class="requirement-text">Not one of your previous 10 password(s)</span>
              </div>
            </div>
          }

          <!-- Confirm Password Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm New Password</mat-label>
            <input
              matInput
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirmPassword"
              [errorStateMatcher]="matcher"
              autocomplete="new-password"
              />
            <mat-icon matPrefix>lock</mat-icon>
            <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" class="password-toggle">
              {{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            @if (confirmPasswordHasError()) {
              <mat-error>
                {{ getConfirmPasswordErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Submit Button -->
        <button
          class="submit-button full-width"
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="form.pristine || !form.valid || loading"
          >
          @if (loading) {
            <mat-icon>refresh</mat-icon>
          }
          {{ loading ? 'Updating...' : 'Update Password' }}
        </button>

        <!-- Back to Sign In Link -->
        <div class="action-links">
          <a [routerLink]="[]" (click)="onNavigateToSignIn()" class="link">
            <mat-icon>arrow_back</mat-icon>
            Back to Sign In
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
